import React__default from 'react';
import { g as getChannelTitle } from '../../chunks/bundle-xuXUit3M.js';
import { useSendbirdStateContext } from '../../useSendbirdStateContext.js';
import { u as useLocalization } from '../../chunks/bundle-DWyboFhb.js';
import { useGroupChannelListContext } from '../context.js';
import { G as GroupChannelListItemView } from '../../chunks/bundle-BPRSyHcX.js';
import '../../chunks/bundle-BXYHgzRj.js';
import '../../chunks/bundle-Bytw3a1z.js';
import '../../chunks/bundle-DokyceKk.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-u-vzK-oc.js';
import '../../chunks/bundle-DNnUvjnZ.js';
import '../../chunks/bundle-CqMQE3-R.js';
import '../../ui/Loader.js';
import '../../chunks/bundle-CGbKAqtd.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-CXA05pe2.js';
import '../../chunks/bundle-Dz4_R08c.js';
import '../../chunks/bundle-CzzanD4i.js';
import '../../chunks/bundle-C12wpwcO.js';
import '../../withSendbird.js';
import '@sendbird/uikit-tools';
import '../../chunks/bundle-CfyvTsrV.js';
import '../../chunks/bundle-Bd7J49Pj.js';
import 'react-dom';
import '../../chunks/bundle-DtujCCHB.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import '../../chunks/bundle-ClfkSu0m.js';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-C4eUm39A.js';
import '../../chunks/bundle-CZybJwCN.js';
import '../../ui/SortByRow.js';
import '../../chunks/bundle-Buop2NT2.js';
import '../../chunks/bundle-Bdc0r0vX.js';
import '../../GroupChannel/components/TypingIndicator.js';
import '../../ui/Badge.js';
import '../../ui/ChannelAvatar.js';
import '../../chunks/bundle-DGC3rWK4.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-Dwpc_MJZ.js';
import '../../chunks/bundle-ydxNdZ_o.js';
import '../../ui/MentionUserLabel.js';
import '../../chunks/bundle-BnRVAspH.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-DmX77DTu.js';
import '../../chunks/bundle-DsnagByW.js';

var GroupChannelListItem = function (_a) {
    var _b, _c, _d;
    var channel = _a.channel, isSelected = _a.isSelected, isTyping = _a.isTyping, renderChannelAction = _a.renderChannelAction, onLeaveChannel = _a.onLeaveChannel, onClick = _a.onClick, tabIndex = _a.tabIndex;
    var config = useSendbirdStateContext().config;
    var stringSet = useLocalization().stringSet;
    var _e = useGroupChannelListContext(), _f = _e.isTypingIndicatorEnabled, isTypingIndicatorEnabled = _f === void 0 ? false : _f, _g = _e.isMessageReceiptStatusEnabled, isMessageReceiptStatusEnabled = _g === void 0 ? false : _g;
    var userId = config.userId;
    var isMessageStatusEnabled = isMessageReceiptStatusEnabled
        && (!((_b = channel.lastMessage) === null || _b === void 0 ? void 0 : _b.isAdminMessage()))
        && ((_d = (_c = channel.lastMessage) === null || _c === void 0 ? void 0 : _c.sender) === null || _d === void 0 ? void 0 : _d.userId) === userId;
    return (React__default.createElement(GroupChannelListItemView, { channel: channel, tabIndex: tabIndex, channelName: getChannelTitle(channel, userId, stringSet), isTyping: isTypingIndicatorEnabled && isTyping, isSelected: isSelected, isMessageStatusEnabled: isMessageStatusEnabled, onClick: onClick, onLeaveChannel: onLeaveChannel, renderChannelAction: renderChannelAction }));
};

export { GroupChannelListItem };
//# sourceMappingURL=GroupChannelListItem.js.map
